/* eslint-disable */
export default {
  today: 'Tänään',
  yesterday: 'Eilen',
  empty: 'Ei puhelutallenteita',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
